module.exports = require('./lib/Observable.js').Observable;



//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/zen-observable/index.js
// module id = QbjI
// module chunks = 22